'use client'

const DONT_SHOW_AGAIN_LOCALSTORAGE_KEY = 'dustin.modal.variants'

import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import router from 'next/router'
import { useState } from 'react'
import {
  ModalDialog,
  ModalDialogContent,
  ModalDialogFooter,
  ModalDialogHeader,
} from '@dustin-web/microsite-components/src/modal-dialog'
import { Checkbox, Label } from '@dustin-web/microsite-components/src/atoms'

export default function UnavailableVariantModal({
  showDialog,
  setShowDialog,
  missingVariantNames = [],
  confirmUrl,
}: {
  showDialog: boolean
  setShowDialog: (arg: boolean) => void
  missingVariantNames: string[]
  confirmUrl: string
}) {
  const { translate } = useTranslations()
  const [dontShowAgainBox, setDontShowAgainBox] = useState(false)
  const toggleCheckbox = () => setDontShowAgainBox(!dontShowAgainBox)

  const handleOnConfirm = () => {
    if (dontShowAgainBox) {
      localStorage.setItem(DONT_SHOW_AGAIN_LOCALSTORAGE_KEY, 'true')
    }

    router.push(confirmUrl)
    setShowDialog(false)
  }

  return (
    <ModalDialog show={showDialog} handleClose={() => setShowDialog(false)}>
      <ModalDialogHeader title={translate('Variants_Only_In_Other_Versions')} />
      <ModalDialogContent>
        <p>{translate('Variants_Changed_Values')}</p>
        <ul className="u-pl-32">
          {missingVariantNames.map((v, key) => (
            <li key={key}>{v}</li>
          ))}
        </ul>
        <div className="d-flex">
          <Checkbox
            id="variant-modal-diff"
            name="variant-modal-diff"
            onChange={toggleCheckbox}
            checked={dontShowAgainBox}
          />
          <Label className="d-flex align-items-center">
            {translate('Variants_Dont_Show_Message')}
          </Label>
        </div>
      </ModalDialogContent>
      <ModalDialogFooter
        showCancel
        cancelText={translate('Cancel')}
        showConfirm
        confirmText={translate('View_Product')}
        onConfirm={handleOnConfirm}
        className="u-pt-0"
      />
    </ModalDialog>
  )
}
